export const sendSingleUserANotification = (
  objContents,
  arrExternalUserIds
) => {
  // alert(
  //   JSON.stringify(objContents) +
  //     " ID LIST: " +
  //     JSON.stringify(arrExternalUserIds)
  // );
  // return "";

  if (window.location.hostname !== "app.brooklynzcommunitysupport.com") {
    console.log(
      "skipping notifications: " +
        JSON.stringify(objContents) +
        " \n" +
        JSON.stringify(arrExternalUserIds)
    );
    return "";
  }

  var headers = {
    "Content-Type": "application/json; charset=utf-8",
    Authorization: "Basic ODU5NDBhNGItYzM2Mi00NDAzLTgyMjYtZTdiZjgzNjk5ZGI2"
  };

  var message = {
    app_id: "0d38dda0-5c2d-45f3-91f5-1ffcf292104b",
    contents: objContents,
    include_external_user_ids: arrExternalUserIds
  };

  //alert(JSON.stringify(arrExternalUserIds));
  let fetchQuery = "https://onesignal.com:443/api/v1/notifications";

  //logger("DEBUG","dbAddRecord(data)", "Adding record to DB: "+fetchQuery+" | "+JSON.stringify(data.payload));
  fetch(fetchQuery, {
    method: "POST",
    body: JSON.stringify(message),
    headers: headers
  })
    .then(res => res.json())
    .then(parsedRes => {
      //logger("DEBUG","dbAddRecord(data)", "Upload to firebase successful " + parsedRes.name);
    })
    .catch(err => {
      if (err !== "") {
        alert(
          "We are unable to complete your request at this time, please check your network connection or contact support.[sendNotification]" +
            err
        );
      }
    });
};



// WEBPACK FOOTER //
// ./src/Services/OneSignal/sendSingleUserANotification.js